import { Controller } from "@hotwired/stimulus"
import { RecoveryCodeCopy } from "../components/recovery-code-copy"

export default class extends Controller {
  static targets = ["source", "feedback"]

  connect() {
    this.copier = new RecoveryCodeCopy({
      source: this.sourceTarget,
      feedback: this.feedbackTarget,
      clipboard: navigator.clipboard
    })
  }

  copy() {
    this.copier.copy()
  }
}
